import * as angular from 'angular';

export const CopyLinkToVizDirective: angular.IDirectiveFactory = function (
  $document,
  $rootScope: angular.IRootScopeService
) {
  const isDropdownOpen = false;
  let documentListenerAdded = false;

  const emitHideMenuEvent = function (event) {
    $rootScope.$emit('dropdown-menu-document-click', event);
  };
  return {
    scope: {
      link: '<',
    },
    restrict: 'E',
    transclude: true,

    template: `<span uib-dropdown on-toggle="toggled(open)">
            <span ng-transclude dropdown-toggle ng-click="show()"></span>
            <div class="dropdown-menu pull-right" ng-class="{'dropdown-open': isDropdownOpen}">
                <h6>Chart view page URL</h6>
                <input class="input-sm" type="text" readonly value="{{ link }}">
            </div>
        </span>`,
    link: function ($scope, $elem) {
      if (!documentListenerAdded) {
        $document[0].addEventListener('click', emitHideMenuEvent);
        documentListenerAdded = true;
      }

      //using the same events as the kabob-menu
      const off = $rootScope.$on('dropdown-menu-document-click', ($event, nativeEvent) => {
        if ($scope.isDropdownOpen && !$elem[0].contains(nativeEvent.target)) {
          $scope.$applyAsync(() => {
            $scope.hide();
          });
        }
      });
      const dropdown = $elem.find('.dropdown-menu')[0];
      const input = $elem.find('input:text');

      const selectAndFocusInput = function () {
        input.focus().select();
        dropdown.removeEventListener('transitionend', selectAndFocusInput);
      };

      ($scope.show = function ($event) {
        this.isDropdownOpen = !this.isDropdownOpen;
        if (this.isDropdownOpen) {
          dropdown.addEventListener('transitionend', selectAndFocusInput);
        }
      }),
        ($scope.hide = function () {
          this.isDropdownOpen = false;
        });

      $scope.$on('$destroy', () => {
        off();
      });
    },
  };
};

CopyLinkToVizDirective.$inject = ['$document', '$rootScope'];
